import React, { useEffect } from 'react';
import Icon from '../AppIcon';
import { isMobileDevice } from '../../utils/deviceDetection';

const ImageSourceModal = ({ isOpen, onClose, onSelectSource }) => {
  if (!isOpen) return null;

  const handleSelectCamera = () => {
    onSelectSource('camera');
    // NO cerrar aquí - se cerrará cuando se seleccione el archivo
  };

  const handleSelectGallery = () => {
    onSelectSource('gallery');
    // NO cerrar aquí - se cerrará cuando se seleccione el archivo
  };

  // Solo mostrar el modal en dispositivos móviles
  useEffect(() => {
    if (isOpen && !isMobileDevice()) {
      // En desktop, seleccionar galería directamente
      onSelectSource('gallery');
    }
  }, [isOpen, onSelectSource]);

  // En desktop no mostrar el modal
  if (!isMobileDevice()) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm max-h-[90vh] overflow-y-auto p-4 sm:p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-slate-800">
            Seleccionar Imagen
          </h2>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 transition-colors p-1"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Description */}
        <p className="text-slate-600 mb-6 text-sm text-center">
          ¿Cómo deseas agregar la imagen?
        </p>

        {/* Options */}
        <div className="space-y-3">
          <button
            onClick={handleSelectCamera}
            className="w-full bg-[#0b3452] hover:bg-[#0b3452]/90 text-white p-4 rounded-lg transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-opacity-50 focus:ring-blue-300"
          >
            <div className="flex items-center justify-center space-x-3">
              <div className="bg-white bg-opacity-20 p-2 rounded-full">
                <Icon name="Camera" size={24} />
              </div>
              <div className="text-left">
                <h3 className="font-semibold">Tomar Foto</h3>
                <p className="text-sm opacity-90">Usar la cámara del dispositivo</p>
              </div>
            </div>
          </button>

          <button
            onClick={handleSelectGallery}
            className="w-full bg-[#0b3452] hover:bg-[#0b3452]/90 text-white p-4 rounded-lg transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-opacity-50 focus:ring-blue-300"
          >
            <div className="flex items-center justify-center space-x-3">
              <div className="bg-white bg-opacity-20 p-2 rounded-full">
                <Icon name="Image" size={24} />
              </div>
              <div className="text-left">
                <h3 className="font-semibold">Galería</h3>
                <p className="text-sm opacity-90">Seleccionar de la galería</p>
              </div>
            </div>
          </button>
        </div>

        {/* Cancel Button */}
        <div className="flex justify-center mt-6">
          <button
            onClick={onClose}
            className="bg-slate-200 text-slate-700 px-6 py-2 rounded-lg font-medium shadow-md hover:bg-slate-300 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-400 text-sm w-full"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageSourceModal;

